import httpClient from './httpClient';

export const PRODUCT_COMPARE_ENDPOINT = '/backoffice/product-compare';

export const getProductComparesAPI = (params = {}) => httpClient.get(PRODUCT_COMPARE_ENDPOINT, { params });
export const getProductCompareAPI = (id) => httpClient.get(`${PRODUCT_COMPARE_ENDPOINT}/${id}`);
export const postProductCompareAPI = (params = {}) => httpClient.post(PRODUCT_COMPARE_ENDPOINT, params);
export const putProductCompareAPI = (id, params = {}) => httpClient.put(`${PRODUCT_COMPARE_ENDPOINT}/${id}`, params);
export const deleteProductCompareAPI = (id) => httpClient.delete(`${PRODUCT_COMPARE_ENDPOINT}/${id}`);

export const verifySkuAPI = (params = {}) => httpClient.post(`${PRODUCT_COMPARE_ENDPOINT}/verify-sku`, params);
